// extracted by mini-css-extract-plugin
module.exports = {"bundleDetailsFooter":"az_LYc","summary":"az_MYc","label":"az_NYc","totalPrice":"az_OYc"};